import { HttpErrorResponse } from '@angular/common/http';
import { ERROR_HANDLER_TYPES, IErrorHandler } from './sentry-error-handler.service';

export class SentryLoggerService {
  readonly _sentry;
  readonly _raven;

  constructor(errorHandler: IErrorHandler, errorHandlerType: ERROR_HANDLER_TYPES) {
    if (errorHandlerType === ERROR_HANDLER_TYPES.RAVEN) {
      this._raven = errorHandler;
    }

    if (errorHandlerType === ERROR_HANDLER_TYPES.SENTRY) {
      this._sentry = errorHandler;
    }
  }

  public httpError(errorResponse: HttpErrorResponse) {
    const params = {
      category: 'Http Error',
      level: 'error',
      data: errorResponse,
      message: errorResponse.message
    };
    const error = new Error(errorResponse.message);
    error.name = 'Http error: ' + errorResponse.status;

    this.addBreadcrumbs(params);
    this.captureException(error);
  }

  public addBreadcrumbs(params: { category?: string, level?: string, data?: any, message?: string }) {
    if (this._raven) {
      this._raven.captureBreadcrumb({ ...params });
    }

    if (this._sentry) {
      this._sentry.addBreadcrumb({ ...params });
    }
  }

  public captureException(error: any) {
    if (this._raven && this._raven.isSetup()) {
      this._raven.captureException(error);
    } else if (this._sentry) {
      this._sentry.captureException(error);
    } else {
      console.error(error);
    }
  }

  public captureMessage(message: string, extra?: any) {
    if (this._raven && this._raven.isSetup()) {
      this._raven.captureMessage(message, { extra });
    } else if (this._sentry) {
      this._sentry.captureMessage(message);
    } else {
      console.error(message, extra);
    }
  }
}
